import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AccountContext = createContext(null);

export function AccountProvider({ children }) {
  const [account, setAccount] = useState(null); // null = unknown/loading, false = anon
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("account_token");
    if (!token) {
      setAccount(false);
      setReady(true);
      return;
    }
    try {
      const r = await api.get("/account/me");
      setAccount(r.data);
    } catch {
      localStorage.removeItem("account_token");
      setAccount(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const setSession = useCallback((token, acc) => {
    localStorage.setItem("account_token", token);
    setAccount(acc);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("account_token");
    setAccount(false);
  }, []);

  return (
    <AccountContext.Provider value={{ account, ready, setSession, logout, refresh }}>
      {children}
    </AccountContext.Provider>
  );
}

export const useAccount = () => useContext(AccountContext);
